import { useState } from "react";
import { SpaceCategory } from "@lifeat/shared/data-models/virtual-space/SpaceCategory";
import MissingSpaceIcon from "/resources/icons/QuestionIcon.svg";

// Emoji source: https://emojipedia.org/
const ArtIcon = "https://pub-aceabaa1ff6f48f7872c8684996a45ee.r2.dev/artist-palette_1f3a8.png";
const BrainIcon = "https://pub-aceabaa1ff6f48f7872c8684996a45ee.r2.dev/brain_1f9e0.png";
const BeachIcon = "https://pub-aceabaa1ff6f48f7872c8684996a45ee.r2.dev/beach-with-umbrella_1f3d6-fe0f.png";
const CelebrityIcon = "https://pub-aceabaa1ff6f48f7872c8684996a45ee.r2.dev/microphone_1f3a4.png";
const CodeIcon = "https://pub-aceabaa1ff6f48f7872c8684996a45ee.r2.dev/laptop_1f4bb.png";
const CityIcon = "https://pub-aceabaa1ff6f48f7872c8684996a45ee.r2.dev/cityscape_1f3d9-fe0f.png";
const CoffeeIcon = "https://pub-aceabaa1ff6f48f7872c8684996a45ee.r2.dev/hot-beverage_2615.png";
const CommuteIcon = "https://pub-aceabaa1ff6f48f7872c8684996a45ee.r2.dev/bullet-train_1f685.png";
const FantasyIcon = "https://pub-aceabaa1ff6f48f7872c8684996a45ee.r2.dev/owl_1f989.png";
const GamesIcon = "https://pub-aceabaa1ff6f48f7872c8684996a45ee.r2.dev/joystick_1f579-fe0f.png";
const KpopIcon = "https://pub-aceabaa1ff6f48f7872c8684996a45ee.r2.dev/admission-tickets_1f39f-fe0f.png";
const LibraryIcon = "https://pub-aceabaa1ff6f48f7872c8684996a45ee.r2.dev/books_1f4da.png";
const LofiIcon = "https://pub-aceabaa1ff6f48f7872c8684996a45ee.r2.dev/crystal-ball_1f52e.png";
const MysteryIcon = "https://pub-aceabaa1ff6f48f7872c8684996a45ee.r2.dev/shushing-face_1f92b.png";
const NatureIcon = "https://pub-aceabaa1ff6f48f7872c8684996a45ee.r2.dev/mountain_26f0-fe0f.png";
const PeopleIcon = "https://pub-aceabaa1ff6f48f7872c8684996a45ee.r2.dev/woman-technologist_1f469-200d-1f4bb.png";
const PetIcon = "https://pub-aceabaa1ff6f48f7872c8684996a45ee.r2.dev/dog_1f415.png";
const SnowIcon = "https://em-content.zobj.net/source/apple/354/snowman-without-snow_26c4.png";
const SpaceIcon = "https://pub-aceabaa1ff6f48f7872c8684996a45ee.r2.dev/ringed-planet_1fa90.png";
const WalkIcon = "https://pub-aceabaa1ff6f48f7872c8684996a45ee.r2.dev/person-walking_1f6b6.png";
const WindowIcon = "https://pub-aceabaa1ff6f48f7872c8684996a45ee.r2.dev/window_1fa9f.png";
const FallIcon = "https://em-content.zobj.net/source/apple/354/fallen-leaf_1f342.png";
const HolidayIcon = "https://em-content.zobj.net/source/apple/354/christmas-tree_1f384.png";
const SpringIcon = "https://em-content.zobj.net/source/apple/391/cherry-blossom_1f338.png";
const MeditationIcon = "https://em-content.zobj.net/source/apple/391/person-in-lotus-position_1f9d8.png";
const LiveIcon = "https://em-content.zobj.net/source/apple/391/movie-camera_1f3a5.png";

const FallbackUnicodeEmojis: Record<SpaceCategory, string> = {
    NATURE: "🏔",
    WINDOW: "🪟",
    BEACH: "🏖",
    CITY: "🏙",
    COFFEE: "☕",
    COMMUTE: "🚅",
    LOFI: "🔮",
    ART: "🎨",
    PET: "🐕",
    SPACE: "🌌",
    PEOPLE: "👩‍💻",
    SNOW: "⛄️",
    KPOP: "🎟",
    CODE: "💻",
    GAMES: "🕹",
    CELEBRITY: "🎤",
    LIBRARY: "📚",
    BRAIN: "🧠",
    FANTASY: "🦉",
    WALK: "🚶",
    MYSTERY: "🤫",
    SPRING: "🌸",
    MEDITATION: "🧘",
    LIVE: "🎥",
    FALL: "🍂",
    HOLIDAY: "🎄",
};

interface SpaceCategoryIconResolverProps {
    category: SpaceCategory;
    className?: string;
}
export function SpaceCategoryIconResolver(props: SpaceCategoryIconResolverProps) {
    let categoryIconSrc = "";

    // Note: keep this switch statement alphabetically ordered.
    switch (props.category) {
        case SpaceCategory.ART: {
            categoryIconSrc = ArtIcon;
            break;
        }
        case SpaceCategory.BEACH: {
            categoryIconSrc = BeachIcon;
            break;
        }
        case SpaceCategory.BRAIN: {
            categoryIconSrc = BrainIcon;
            break;
        }
        case SpaceCategory.CELEBRITY: {
            categoryIconSrc = CelebrityIcon;
            break;
        }
        case SpaceCategory.CITY: {
            categoryIconSrc = CityIcon;
            break;
        }
        case SpaceCategory.COFFEE: {
            categoryIconSrc = CoffeeIcon;
            break;
        }
        case SpaceCategory.CODE: {
            categoryIconSrc = CodeIcon;
            break;
        }
        case SpaceCategory.COMMUTE: {
            categoryIconSrc = CommuteIcon;
            break;
        }
        // NOTE: temporary/seasonal category
        case SpaceCategory.FALL: {
            categoryIconSrc = FallIcon;
            break;
        }
        case SpaceCategory.FANTASY: {
            categoryIconSrc = FantasyIcon;
            break;
        }
        case SpaceCategory.GAMES: {
            categoryIconSrc = GamesIcon;
            break;
        }
        // NOTE: temporary/seasonal category
        case SpaceCategory.HOLIDAY: {
            categoryIconSrc = HolidayIcon;
            break;
        }
        case SpaceCategory.KPOP: {
            categoryIconSrc = KpopIcon;
            break;
        }
        case SpaceCategory.LIBRARY: {
            categoryIconSrc = LibraryIcon;
            break;
        }
        case SpaceCategory.LOFI: {
            categoryIconSrc = LofiIcon;
            break;
        }
        case SpaceCategory.MYSTERY: {
            categoryIconSrc = MysteryIcon;
            break;
        }
        case SpaceCategory.NATURE: {
            categoryIconSrc = NatureIcon;
            break;
        }
        case SpaceCategory.PEOPLE: {
            categoryIconSrc = PeopleIcon;
            break;
        }
        case SpaceCategory.PET: {
            categoryIconSrc = PetIcon;
            break;
        }
        case SpaceCategory.SNOW: {
            categoryIconSrc = SnowIcon;
            break;
        }
        case SpaceCategory.SPACE: {
            categoryIconSrc = SpaceIcon;
            break;
        }
        case SpaceCategory.WALK: {
            categoryIconSrc = WalkIcon;
            break;
        }
        case SpaceCategory.WINDOW: {
            categoryIconSrc = WindowIcon;
            break;
        }
        case SpaceCategory.SPRING: {
            categoryIconSrc = SpringIcon;
            break;
        }
        case SpaceCategory.MEDITATION: {
            categoryIconSrc = MeditationIcon;
            break;
        }
        case SpaceCategory.LIVE: {
            categoryIconSrc = LiveIcon;
            break;
        }
        default: {
            break;
        }
    }

    const [errorLoadingImage, setErrorLoadingImage] = useState(false);
    const handleImageError = () => {
        setErrorLoadingImage(true);
    };

    // If the image fails to load, switch to the fallback unicode emoji
    const emojiImage = errorLoadingImage ? (
        <div className={`space-category-icon ${props.className}`}>{FallbackUnicodeEmojis[props.category] ?? "❓"}</div>
    ) : (
        <img
            className={`space-category-icon ${props.className}`}
            src={categoryIconSrc}
            alt={FallbackUnicodeEmojis[props.category] ?? "❓"}
            onError={handleImageError}
            referrerPolicy={"no-referrer"}
        />
    );

    return categoryIconSrc === "" ? <MissingSpaceIcon className={`space-category-icon`} /> : emojiImage;
}
